// ---------------------------------------------------------------
// Temporary "watches" — the owner asks the car to keep an eye out for a while:
//   "for the next 30 minutes, count how many times the car turns on"
//   "alert me every time the car turns on"
// A watch has an event, a mode (count vs notify-each) and an expiry.
// AlertWatcher feeds ignition/moving transitions in; watches banner/speak/text.
// ---------------------------------------------------------------

const KEY = 'dd-car-watches';
const get = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
const save = (a) => localStorage.setItem(KEY, JSON.stringify(a.slice(-100)));

export const getWatches = () => get().filter((w) => new Date(w.until) > new Date());
export function addWatch(w) { const a = get(); const rec = { id: `W${Date.now()}`, count: 0, createdAt: new Date().toISOString(), ...w }; a.push(rec); save(a); return rec; }
export function removeWatch(id) { save(get().filter((w) => w.id !== id)); }

const phrase = (e) => (e === 'ignitionOn' ? 'turned on' : e === 'ignitionOff' ? 'turned off' : 'started moving');
const title = (e) => (e === 'ignitionOn' ? 'Vehicle turned on' : e === 'ignitionOff' ? 'Vehicle turned off' : 'Vehicle started moving');

// call when a device fires an event; returns notify alerts (for notify-mode watches)
export function noteEvent(deviceId, event, deviceName) {
  const now = new Date(); const a = get(); const out = [];
  a.forEach((w) => {
    if (String(w.deviceId) !== String(deviceId) || w.event !== event || new Date(w.until) < now) return;
    w.count = (w.count || 0) + 1;
    if (w.mode !== 'count') {
      out.push({ key: `watch:${w.id}:${w.count}`, entity: deviceName, severity: 'warn', icon: '🔔', title: title(event), info: `${deviceName} ${phrase(event)} (watch alert #${w.count}).`, text: `🔔 ${deviceName} ${phrase(event)} at ${now.toLocaleTimeString()}.` });
    }
  });
  save(a);
  return out;
}

// summaries for watches whose window just ended (count-mode reports the tally)
export function expireWatches(nameById) {
  const now = new Date(); const a = get(); const keep = []; const out = [];
  a.forEach((w) => {
    if (new Date(w.until) <= now) {
      if (w.mode === 'count') {
        const nm = nameById[w.deviceId] || 'The car';
        out.push({ key: `watchdone:${w.id}`, entity: nm, severity: 'info', icon: '⏱️', title: 'Watch finished', info: `${nm} ${phrase(w.event)} ${w.count || 0} time(s) in the last ${w.minutes} min.`, text: `⏱️ In the last ${w.minutes} minutes, ${nm} ${phrase(w.event)} ${w.count || 0} time(s).` });
      }
    } else keep.push(w);
  });
  save(keep);
  return out;
}
